var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0517 14.3887C17.6393 12.9551 19.601 11.8626 19.77 11.7777C20.3109 11.4874 20.8695 10.7192 19.77 10.1225C19.4151 9.93488 17.5038 8.87646 15.0517 7.51147L11.6523 10.9756L15.0517 14.3887V14.3887Z",
    fill: "#FFD900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6525 10.9756L0.828613 21.9832C1.08268 22.0171 1.3695 21.9492 1.70767 21.7616C2.41763 21.3694 9.94398 17.222 15.0518 14.3895L11.6525 10.9756Z",
    fill: "#F43249"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6527 10.9755L15.0521 7.52842C15.0521 7.52842 2.46919 0.599265 1.70788 0.190229C1.42106 0.0188124 1.09963 -0.032106 0.812012 0.0188124L11.6527 10.9755Z",
    fill: "#00EE76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6525 10.9755L0.81177 0.0187988C0.371805 0.12144 0 0.513664 0 1.31581V20.6861C0 21.4203 0.287703 21.9491 0.82859 22.0001L11.6525 10.9755Z",
    fill: "#00D3FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.a2884a4668fa8a156b6875291de972d3.svg";
export { ForwardRef as ReactComponent };